import React from 'react';
import {Col} from "antd";
import {IPropsChildren} from "../../../../../util/varibles/interface";

interface IProps extends IPropsChildren {
    sm?: number
}

const Section: React.FC<IProps> = ({children, sm = 12}) => {
    return <Col className="gutter-row" span={24} sm={sm}>
        <div className='flex flex-col gap-[2px]'>
            {children}
        </div>
    </Col>;
};

export default Section;